import { useState } from "react";
import { topicIndex } from "@/mocks/homeData";
import SectionHeading from "./SectionHeading";

const indexFilters = ["全部", "综艺", "品牌", "剧组", "直播"];

export default function TrendingIndex() {
  const [filter, setFilter] = useState("全部");

  const rows = filter === "全部" ? topicIndex : topicIndex.filter((item) => item.category === filter);

  return (
    <section id="index" className="scroll-mt-20 border-b border-background-300/70 bg-background-100">
      <div className="mx-auto w-full px-4 py-10 md:px-6 md:py-14">
        <SectionHeading
          eyebrow="TOPIC INDEX"
          title="话题索引：按序号快速定位正在发酵的争议"
          desc="把当日讨论量靠前的话题编成索引，标题、分类、热度与新增讨论一目了然，适合先扫一遍再挑着细看。"
          aside={
            <div className="flex flex-wrap gap-1.5 rounded-md bg-background-200 p-1">
              {indexFilters.map((item) => (
                <button
                  key={item}
                  type="button"
                  onClick={() => setFilter(item)}
                  className={`whitespace-nowrap rounded-md px-3 py-1.5 font-label text-xs transition-colors ${
                    filter === item
                      ? "bg-background-50 text-primary-700 shadow-none"
                      : "text-foreground-600 hover:text-foreground-900"
                  }`}
                >
                  {item}
                </button>
              ))}
            </div>
          }
        />

        <div className="grid grid-cols-1 gap-x-6 gap-y-1.5 md:grid-cols-2">
          {rows.map((item) => (
            <a
              key={item.no}
              href="#flow"
              className="group flex cursor-pointer items-center gap-3 rounded-md border-b border-background-300/60 px-2 py-2.5 transition-colors hover:bg-primary-50"
            >
              <span className="font-heading text-lg font-black text-primary-500">{item.no}</span>
              <div className="min-w-0 flex-1">
                <p className="truncate font-label text-sm font-medium text-foreground-900 group-hover:text-primary-700">
                  {item.title}
                </p>
                <p className="mt-0.5 truncate font-label text-xs text-foreground-500">{item.note}</p>
              </div>
              <span className="shrink-0 rounded border border-secondary-200 bg-secondary-100 px-2 py-0.5 font-label text-xs text-secondary-900">
                {item.category}
              </span>
              <span className="hidden shrink-0 items-center gap-1 font-label text-xs text-foreground-600 sm:flex">
                <span className="flex h-3.5 w-3.5 items-center justify-center text-accent-600">
                  <i className="ri-fire-line text-xs"></i>
                </span>
                {item.heat}
              </span>
            </a>
          ))}
        </div>

        {rows.length === 0 ? (
          <p className="rounded-lg border border-background-300 bg-background-50 px-4 py-8 text-center font-label text-sm text-foreground-500">
            该分类下暂时没有在榜话题，换个分类看看。
          </p>
        ) : null}
      </div>
    </section>
  );
}